// Fills the header heart while the customer has anything saved. The list comes from Swym, so it is
// read once on load and then kept in step with the wishlist:updated event the drawer dispatches.
class WishlistIndicator extends HTMLElement {
  constructor() {
    super();

    this.defaultIcon = this.querySelector("[data-wishlist-icon-default]");
    this.filledIcon = this.querySelector("[data-wishlist-icon-filled]");
  }

  connectedCallback() {
    this.refresh();

    this.handleUpdate = () => this.refresh();
    document.addEventListener("wishlist:updated", this.handleUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener("wishlist:updated", this.handleUpdate);
  }

  setFilled(filled) {
    if (this.defaultIcon) this.defaultIcon.hidden = filled;
    if (this.filledIcon) this.filledIcon.hidden = !filled;
  }

  refresh() {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push((swat) => {
      swat.fetchLists({
        callbackFn: (lists) => {
          const count = (lists || []).reduce(
            (total, list) => total + (list.listcontents || []).length,
            0,
          );

          this.setFilled(count > 0);
        },
        errorFn: () => this.setFilled(false),
      });
    });
  }
}

if (!customElements.get("wishlist-indicator")) {
  customElements.define("wishlist-indicator", WishlistIndicator);
}
